import { activityTypeVariantData } from 'utils/activity-type-variant-util';
import { ClientDevice } from 'src/graph/types/schema-generated-types';

export default {
  currentRound({ progress, rounds }) {
    const { roundIndex } = progress;

    return roundIndex >= 0 ? rounds[progress.roundIndex] : {};
  },

  currentStep({ progress, stepIndicator }, { currentRound }) {
    if (!currentRound) return {};
    const currentStep = currentRound[stepIndicator]?.[progress.stepIndex];

    return currentStep || {};
  },

  totalStepsInRound({ stepIndicator }, { currentRound }) {
    if (!currentRound) return 0;
    return currentRound[stepIndicator]?.length ?? 0;
  },

  isLastStepInRound({ progress }, getters) {
    return progress.stepIndex >= getters.totalStepsInRound - 1;
  },

  isLastRound({ progress, rounds }) {
    return progress.roundIndex >= rounds.length - 1;
  },

  activityInProgress({ progress }) {
    return progress.roundIndex >= 0;
  },

  isEndOfActivity({ progress, rounds }, getters) {
    return (
      progress.stepIndex >= getters.totalStepsInRound - 1 &&
      progress.roundIndex >= rounds.length - 1
    );
  },

  homeRowVideo: ({ data: { videos } }) => {
    if (!videos || !videos.length) return false;
    const video = videos.find(v => v && !!v.curriculumWeeks);
    return video ? video.video : undefined;
  },

  templateVideo: ({ data: { videos } }, activity) => {
    if (!videos || !videos.length) return false;
    const video = videos.find(v => v && !v.curriculumWeeks && !v.module);
    return video && !activity?.isSpotCheckActivity
      ? { ...video.video, autoplay: video.autoPlay }
      : undefined;
  },

  moduleVideo: ({ data: { videos } }) => {
    if (!videos || !videos.length) return false;
    const video = videos.find(v => v && !!v.moduleId);
    return video?.video;
  },

  spotCheckVideo: ({ data: { activityTypeVariant, videos } }, activity) => {
    if (!videos?.length && !activityTypeVariant?.videos?.length) return false;
    const video = videos?.find(v => v && !v.curriculumWeeks);
    const activityVariantTypeVideo = activityTypeVariant.videos?.find(
      v => v.device === ClientDevice.DESKTOP
    )?.video;
    return (video || activityVariantTypeVideo) && activity?.isSpotCheckActivity
      ? video?.video ?? activityVariantTypeVideo
      : undefined;
  },

  activityTitle: ({ data }) => {
    if (!data || !data.activityId) return { display: '', name: '' };

    const { variant } = data.activityTypeVariant;

    const activityTypeVariant = activityTypeVariantData.find(
      activityTypeVariant => activityTypeVariant.variant === variant
    );
    if (!activityTypeVariant) return { display: '', name: '' };

    return {
      display: activityTypeVariant.displayName,
      name: activityTypeVariant.component,
      imageFileName: activityTypeVariant.variant
    };
  },

  isAssessmentAcceleratorActivity: ({ data: { category } }) => {
    return category && category.includes('ASSESSMENT_ACCELERATOR');
  },

  hasCustomNextButton: ({ data }) => {
    if (!data || !data.activityId) return false;

    const { variant } = data.activityTypeVariant;

    const activityTypeVariant = activityTypeVariantData.find(
      activityTypeVariant => activityTypeVariant.variant === variant
    );
    if (!activityTypeVariant) return false;
    return activityTypeVariant.hasCustomNextButton;
  },

  isSpotCheckActivity: ({ data: { type: activityName } }) =>
    activityName &&
    ['ALettersKPM', 'AParagraphWPM', 'ASentencesWPM', 'AWordsWPM'].indexOf(activityName) >= 0,

  assessmentAcceleratorModuleProgress: ({ data }) => ({
    currentActivity: data.moduleActivityNumber,
    totalActivities: data.moduleActivityCount
  }),

  showAssessmentAcceleratorIntro: ({ data }) => data.showIntro
};
